export const COMPONENT = Symbol("sol.component");
export const CONTEXT = Symbol("sol.context");
export const ROUTE = Symbol("sol.route");
